import React from 'react';
import { Box, Checkbox, Typography, Link, FormHelperText } from '@mui/material';

/**
 * Required SMS-consent opt-in checkbox (CTIA / toll-free compliance).
 *
 * Replaces the passive disclosure paragraph on every phone-entry screen. The
 * box is unchecked by default (consent must be voluntary) and the form must
 * block submission until it is checked. Controlled by the parent form.
 *
 * Props: checked (bool), onChange (fn(bool)), error (string), sx.
 */
function SmsConsentCheckbox({ checked, onChange, error, sx }) {
  return (
    <Box sx={{ mb: 1.5, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
        <Checkbox
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          size="small"
          sx={{ p: 0.25, mt: '-1px' }}
          inputProps={{ 'aria-label': 'Agree to receive SMS messages' }}
        />
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          sx={{ lineHeight: 1.45, fontSize: '0.7rem', cursor: 'pointer', userSelect: 'none' }}
          onClick={() => onChange(!checked)}
        >
          I agree to receive SMS messages from sqip for verification and account
          notifications. Reply STOP to opt out, HELP for help. Msg &amp; data rates
          may apply. Msg frequency varies.{' '}
          <Link
            href="/legal/terms" target="_blank" rel="noopener noreferrer"
            underline="always" color="inherit" onClick={(e) => e.stopPropagation()}
          >
            Terms of Service
          </Link>
          {' | '}
          <Link
            href="/legal/privacy" target="_blank" rel="noopener noreferrer"
            underline="always" color="inherit" onClick={(e) => e.stopPropagation()}
          >
            Privacy Policy
          </Link>
        </Typography>
      </Box>
      {error && (
        <FormHelperText error sx={{ ml: 3.5, mt: 0.25, fontSize: '0.72rem' }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
}

export default SmsConsentCheckbox;
